import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { applySession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } })
      .then(({ data }) => {
        applySession(data);
        navigate("/dashboard", { replace: true });
      })
      .catch((e) => {
        toast.error(errMsg(e, "Falha no login com Google"));
        navigate("/login", { replace: true });
      });
  }, [location.hash, navigate, applySession]);

  return null;
}
